import { BaseDto } from './base.dto';

export class CustomerAllergenDto extends BaseDto {
  customerId: number;
  allergenId: number;
}
